import { auth } from "@/lib/firebase";
import { useAuthStore } from "@/store/auth/authUserStore";
import useFolderStore from "@/store/ui/folderStore";
import useWorkflowStore from "@/store/workflow/workflowStore";
import type { CustomTheme } from "@/theme/theme";
import storage from "@/utils/storage";
import {
  Avatar,
  Badge,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/system";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const UserMenu = () => {
  const { user, setUser } = useAuthStore();
  const { closeAllFolders } = useFolderStore();
  const { setWorkflowListScrollPosition } = useWorkflowStore();
  const theme: CustomTheme = useTheme();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = async () => {
    // フォルダを全て閉じる
    closeAllFolders();
    // スクロール位置を最上部にリセット
    setWorkflowListScrollPosition(0);
    await auth.signOut();
    storage.clearToken();
    setUser(null);

    window.location.assign(window.location.origin as unknown as string);
  };

  const navigation = useNavigate();
  const handleClickMenuItem = (path: string) => {
    navigation(path);
  };

  return (
    <div>
      <Box
        sx={{
          backgroundColor: theme.palette.secondary.dark,
          padding: "4px 0px",
          borderRadius: "4px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "30px",
          "&:hover": {
            backgroundColor: theme.palette.secondary.light,
          },
        }}
      >
        <IconButton
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          color="inherit"
          onClick={handleClick}
          sx={{
            display: "flex",
            border: "none",
            padding: "0px",
            "&:hover": {
              border: "none",
            },
          }}
        >
          <Typography
            sx={{
              color: "white",
              fontWeight: "bold",
              Weight: "bold",
              fontSize: theme.typography.body1.fontSize,
              padding: "10px 20px",
            }}
          >
            {user?.organization?.name}
          </Typography>
          <Badge badgeContent={0} color="secondary">
            <Avatar
              sx={{
                backgroundColor: "#F57510",
                height: "24px",
                width: "24px",
                marginRight: "3px",
              }}
              variant="rounded"
            >
              <Typography
                sx={{
                  fontSize: theme.typography.caption.fontSize,
                  fontWeight: "bold",
                }}
              >
                {user?.avatar_name}
              </Typography>
            </Avatar>
          </Badge>
        </IconButton>
      </Box>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem
          onClick={() => {
            handleClickMenuItem("/newPasswordSetting/");
          }}
        >
          パスワード再設定
        </MenuItem>
        <MenuItem onClick={handleLogout}>ログアウト</MenuItem>
      </Menu>
    </div>
  );
};
